import React, { useCallback } from "react";
import classNames from "classnames";
import styles from "./enter-handler.module.scss";

type EnterHandlerProps = React.PropsWithChildren<{
  onEnter?: (event: React.KeyboardEvent<HTMLDivElement>) => void;
  className?: string;
}>;

const EnterHandler = (props: EnterHandlerProps) => {
  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLDivElement>) => {
      if (event.code === "Enter") {
        event.preventDefault();
        props.onEnter?.(event);
      }
    },
    [props.onEnter],
  );

  return (
    <div className={classNames(styles.root, props.className)} tabIndex={0} onKeyDown={handleKeyDown}>
      {props.children}
    </div>
  );
};

export default EnterHandler;
